import { useAreLeadershipManagementFlightsEnabled } from './useAreLeadershipManagementFlightsEnabled';
import { useViewerCanAccessLeaderManagement } from './useViewerCanAccessLeaderManagement';

type UseShowLeaderSettings = () => boolean;
export const useShowLeaderSettings: UseShowLeaderSettings = () => {
  const areLeadershipManagementFlightsEnabled = useAreLeadershipManagementFlightsEnabled();
  const canAccessLeadershipManagement = useViewerCanAccessLeaderManagement();

  return areLeadershipManagementFlightsEnabled && canAccessLeadershipManagement;
};
